export enum ContractorTypes {
    Carrier = "Carrier",
    Client = "Client",
    CustomsAgency = "CustomsAgency",
    Other = "Other",
    Partner = "Partner",
    Payer = "Payer",
    Shipowner = "Shipowner",
    Warehouse = "Warehouse",
    Factor = "Factor",
}
